import TabsErp from "../../../../../components/tabs/TabsErp";
import { useState } from "react";
import { FornecedoresBodyContextProvider } from "../../contexts/FornecedoresBodyContext";
import useFornecedoresBodyController from "../../controllers/FornecedoresBodyController";
import { CustomButton, CustomDialogContent } from "../../styles/styles";
import { DialogActions } from "@material-ui/core";

const View = ({ setOpen, setLoading }) => {
  const { tabTitles, tabContents, handleSaveSupplierParams } =
    useFornecedoresBodyController(setLoading, setOpen);

  const [tabIndex, setTabIndex] = useState(0);

  return (
    <>
      <CustomDialogContent>
        <TabsErp
          headers={tabTitles}
          tabIndex={tabIndex}
          children={tabContents}
          onChange={(event, value) => {
            if (Number.isInteger(value)) setTabIndex(value);
          }}
        />
      </CustomDialogContent>
      <DialogActions>
        <CustomButton
          onClick={handleSaveSupplierParams}
          label="Salvar"
          bgcolor="primary"
          hovercolor="tertiary"
        />
      </DialogActions>
    </>
  );
};

const FornecedoresBody = ({ ...props }) => (
  <FornecedoresBodyContextProvider>
    <View {...props} />
  </FornecedoresBodyContextProvider>
);
export default FornecedoresBody;
